import { useTranslation } from 'react-i18next';
import { Settings, Sun, Moon, Globe } from 'lucide-react';
import { useGlobal } from '@/shared/contexts/GlobalContext';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const languages = [
  { code: 'ru', label: 'Русский' },
  { code: 'en', label: 'English' },
  { code: 'uz', label: "O'zbek" },
];

export default function SettingsPanel({ open, onOpenChange }) {
  const { t, i18n } = useTranslation('chat');
  const { theme, setTheme, lang, setLang } = useGlobal();

  const handleLanguageChange = (code) => {
    setLang(code);
    i18n.changeLanguage(code);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2">
            <Settings className="size-4" />
            {t('settings', 'Settings')}
          </SheetTitle>
          <SheetDescription>
            {t('settings_description', 'Configure your preferences')}
          </SheetDescription>
        </SheetHeader>

        <div className="space-y-6 px-4">
          {/* Theme */}
          <div className="space-y-2">
            <Label>{t('theme', 'Theme')}</Label>
            <div className="flex gap-2">
              <Button
                variant={theme === 'light' ? 'default' : 'outline'}
                size="sm"
                className="flex-1 gap-2"
                onClick={() => setTheme('light')}
              >
                <Sun className="size-4" />
                {t('light', 'Light')}
              </Button>
              <Button
                variant={theme === 'dark' ? 'default' : 'outline'}
                size="sm"
                className="flex-1 gap-2"
                onClick={() => setTheme('dark')}
              >
                <Moon className="size-4" />
                {t('dark', 'Dark')}
              </Button>
            </div>
          </div>

          <Separator />

          {/* Language */}
          <div className="space-y-2">
            <Label className="flex items-center gap-2">
              <Globe className="size-4" />
              {t('language', 'Language')}
            </Label>
            <Select value={lang} onValueChange={handleLanguageChange}>
              <SelectTrigger className="w-full">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {languages.map((l) => (
                  <SelectItem key={l.code} value={l.code}>
                    {l.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <Separator />

          {/* App info */}
          <div className="space-y-1">
            <p className="text-xs text-muted-foreground">Zehn AI Platform</p>
            <p className="text-xs text-muted-foreground">v1.0.0</p>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
